import React from 'react';
import Select from '@atlaskit/select';
import { Field } from '@atlaskit/form';
import { CapabilityInput } from '@atlassiansox/phobos-client-ts';

import { ConditionalErrorMessage } from '@/components/composed/forms/form-errors';

const DEFAULT_TIER = 3;

const capabilityTierOptions: FieldOption<number>[] = [
  { label: 'Capability Tier 1', value: 1 },
  { label: 'Capability Tier 2', value: 2 },
  { label: 'Capability Tier 3', value: 3 },
];

type CapabilityTierFieldProps = { importance: CapabilityInput['importance'] | undefined };

const CapabilityTierField: React.FC<CapabilityTierFieldProps> = React.memo(
  function CapabilityTierField({ importance = DEFAULT_TIER }) {
    return (
      <Field<FieldOption<number>>
        name="importance"
        label="Capability Tier"
        defaultValue={capabilityTierOptions[importance - 1]}
      >
        {({ fieldProps: { id, ...rest }, error }) => (
          <>
            <Select
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...rest}
              inputId={id}
              options={capabilityTierOptions}
              defaultOptions
              placeholder="Choose a Capability Tier"
              validationState={error ? 'error' : 'default'} // https://product-fabric.atlassian.net/browse/DSP-821
            />
            <ConditionalErrorMessage error={error} />
          </>
        )}
      </Field>
    );
  }
);

export default CapabilityTierField;
